import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99997 4.99997C8.12784 4.99997 8.25584 5.04884 8.35347 5.14647L13.3535 10.1465C13.5488 10.3418 13.5488 10.6582 13.3535 10.8535C13.1581 11.0487 12.8417 11.0488 12.6465 10.8535L7.99997 6.20697L3.35347 10.8535C3.15809 11.0488 2.84172 11.0488 2.64647 10.8535C2.45122 10.6581 2.45109 10.3417 2.64647 10.1465L7.64647 5.14647C7.74409 5.04884 7.87209 4.99997 7.99997 4.99997Z",
      fill: "#999999"
    }, null, -1)
  ])))
}